import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Tag from '../../../Tags/Tag';
import balance from '../../../../assets/recommended/balance.png';
import { setCurrentCourse } from '../../../../store/actions/appActions';
import { COURSES } from '../../../../constants/courses';
import { CoursesModifications } from '../../../../types/courses/courses';

import { RestoreWrapper, TagsWrapper, RestoreImage, RestoreContent, RestoreBottom } from './styled';
import useMediaQuery from '../../../../utils/breakpoints/useMediaQuery';

const BallanceProgressio = () => {
   const { t } = useTranslation();
   const dispatch = useDispatch();
   const { isMobile } = useMediaQuery();

   const handleSelectCourse = () => {
      dispatch(setCurrentCourse({ courseModification: COURSES.maintainBalanceProposal as CoursesModifications }));
   }

   return (
      <Link to={`/cabinet/${COURSES.maintainBalanceProposal}`} >
         <RestoreWrapper onClick={handleSelectCourse} isMobile={isMobile}>
            <RestoreImage isMobile={isMobile} src={balance} />
            <RestoreContent isMobile={isMobile} >
               <TagsWrapper>
                  <Tag name="Teens" />
               </TagsWrapper>
               <RestoreBottom isMobile={isMobile}> 
                  <h1>{t('course.maintainBalanceProposal.title')}</h1>
                  <p>{t('course.maintainBalanceProposal.description')}</p>
            </RestoreBottom>  
            </RestoreContent>
         </RestoreWrapper>
      </Link>
   );
};

export default BallanceProgressio;